export const PLANS = [
  {
    id: 'starter',
    name: 'Starter',
    price: 9,
    credits: 3,
    extraCreditPrice: 4,
    maxProperties: 1,
    featured: false,
    features: [
      '3 credits / month',
      '1 property',
      'Extra credits at $4 each',
      'Email support',
      'Basic activity reports',
    ],
  },
  {
    id: 'pro',
    name: 'Pro',
    price: 19,
    credits: 10,
    extraCreditPrice: 3,
    maxProperties: 3,
    featured: true,
    features: [
      '10 credits / month',
      'Up to 3 properties',
      'Extra credits at $3 each',
      'Priority support',
      'Full photo & video reports',
      'Agent chat access',
    ],
  },
  {
    id: 'family',
    name: 'Family',
    price: 39,
    credits: 25,
    extraCreditPrice: 2,
    maxProperties: null,
    featured: false,
    features: [
      '25 credits / month',
      'Unlimited properties',
      'Extra credits at $2 each',
      '24/7 WhatsApp support',
      'Full photo & video reports',
      'Agent chat access',
      'Monthly summary PDF',
    ],
  },
];

export const SERVICES = [
  {
    id: 'farm_visit',
    name: 'Farm Visit & Report',
    cost: 1,
    icon: '🌾',
    tab: 'farm',
    description: 'Agent visits your farm and sends a detailed photo & video report.',
    note: null,
  },
  {
    id: 'rent_collection',
    name: 'Rent Collection',
    cost: 1,
    icon: '🏠',
    tab: 'rentals',
    description: 'Collect rent from tenants on your behalf via M-Pesa or cash.',
    note: '+ 5% commission on amount collected',
  },
  {
    id: 'bill_payment',
    name: 'Bill / Fee Payment',
    cost: 0.5,
    icon: '💳',
    tab: 'payments',
    description: 'Pay KPLC, water, school fees, NTSA, county or any other bill.',
    note: null,
  },
  {
    id: 'simple_errand',
    name: 'Simple Errand',
    cost: 1,
    icon: '🏃',
    tab: 'errands',
    description: 'Pick up, drop off, or any quick task completed in under 2 hours.',
    note: null,
  },
  {
    id: 'document_handling',
    name: 'Document Handling',
    cost: 1,
    icon: '📄',
    tab: 'documents',
    description: 'Collect, sign, deliver, scan or notarise important documents.',
    note: null,
  },
  {
    id: 'site_supervision',
    name: 'Site Supervision',
    cost: 2,
    icon: '🏗️',
    tab: 'projects',
    description: 'Full-day oversight of your construction or renovation project.',
    note: null,
  },
  {
    id: 'government_errand',
    name: 'Government Errand',
    cost: 3,
    icon: '🏛️',
    tab: 'errands',
    description: 'Handle tasks at Lands, KRA, Huduma Centre or county offices.',
    note: null,
  },
  {
    id: 'complex_errand',
    name: 'Complex Errand',
    cost: 3,
    icon: '⚙️',
    tab: 'errands',
    description: 'Multi-step tasks requiring planning, coordination or multiple stops.',
    note: null,
  },
];

export const TOPUP_PACKAGES = [
  { id: 'pkg5',  credits: 5,  price: 18,  pricePerCredit: 3.60, popular: false },
  { id: 'pkg10', credits: 10, price: 30,  pricePerCredit: 3.00, popular: true  },
  { id: 'pkg25', credits: 25, price: 60,  pricePerCredit: 2.40, popular: false },
  { id: 'pkg50', credits: 50, price: 100, pricePerCredit: 2.00, popular: false },
];

export const MOCK_AGENT = {
  name: 'James Mwangi',
  initials: 'JM',
  location: 'Nairobi, Kenya',
  phone: '+254 712 345 678',
  rating: 4.8,
  completedJobs: 127,
  available: true,
};

export const NAV_TABS = [
  { id: 'overview',  label: 'Overview',  icon: '⬡' },
  { id: 'farm',      label: 'Farm',      icon: '🌾' },
  { id: 'rentals',   label: 'Rentals',   icon: '🏠' },
  { id: 'projects',  label: 'Projects',  icon: '🏗️' },
  { id: 'payments',  label: 'Payments',  icon: '💳' },
  { id: 'documents', label: 'Documents', icon: '📄' },
  { id: 'errands',   label: 'Errands',   icon: '🏃' },
];

export const MOCK_ACTIVITIES = [
  {
    id: 1,
    service: 'Farm Visit & Report',
    icon: '🌾',
    cost: 1,
    date: '2026-05-10',
    status: 'completed',
    note: 'Maize crop looking healthy. Photos attached.',
  },
  {
    id: 2,
    service: 'Rent Collection',
    icon: '🏠',
    cost: 1,
    date: '2026-05-05',
    status: 'completed',
    note: 'Collected KES 24,000 from 3 tenants. M-Pesa sent.',
  },
  {
    id: 3,
    service: 'Bill / Fee Payment',
    icon: '💳',
    cost: 0.5,
    date: '2026-04-28',
    status: 'completed',
    note: 'KPLC prepaid KES 4,200. Token sent via SMS.',
  },
];
